import angular from 'angular';

angular
    .module('depositor')

    .factory('DepositorService', [
        '$resource',
        'API_CONFIG',
        function($resource, API_CONFIG) {
            var Depositor = $resource(
                API_CONFIG.url + '/v1/depositor/:depositorId',
                { depositorId: '@Id' },
                {
                    // Recherche les déposants suivant des filtres
                    search: {
                        url: API_CONFIG.url + '/v1/depositor/search',
                        method: 'POST',
                        isArray: false
                    },
                    updateDepositor: {
                        url: API_CONFIG.url + '/v1/depositor',
                        method: 'POST',
                        isArray: false
                    }
                }
            );

            return Depositor;
        }
    ]);
